import { createApp } from 'vue'
import App from './App.vue'
import './assets/fonts.css'
import './assets/styles.css'

createApp(App).mount('#app')
